import EntryActionTypes from '../constants/EntryActionTypes';

const fetchContentCardDefaultsInCurrentBoard = () => ({
  type: EntryActionTypes.CONTENT_CARD_DEFAULTS_IN_CURRENT_BOARD_FETCH,
});

const createContentCardDefaultInCurrentBoard = (type, data = {}) => ({
  type: EntryActionTypes.CONTENT_CARD_DEFAULT_IN_CURRENT_BOARD_CREATE,
  payload: {
    type,
    data,
  },
});

const updateContentCardDefault = (id, data) => ({
  type: EntryActionTypes.CONTENT_CARD_DEFAULT_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteContentCardDefault = (id) => ({
  type: EntryActionTypes.CONTENT_CARD_DEFAULT_DELETE,
  payload: {
    id,
  },
});

export default {
  fetchContentCardDefaultsInCurrentBoard,
  createContentCardDefaultInCurrentBoard,
  updateContentCardDefault,
  deleteContentCardDefault,
};

